import React, { Component, Fragment } from "react";

import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { ProfileType, BookingStatusType } from "../../../types/enum";

import SelectField from "../../fields/SelectField";

import { Grid, TextField, Button } from "@material-ui/core";
import Countries from "../../../lookup/Country";
import moment from "moment";
import Switch from "@material-ui/core/Switch";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import CloudDownload from "@material-ui/icons/CloudDownload";
import { Storage } from "aws-amplify";

const API_ROOT = process.env.REACT_APP_MAIN_SERVICE_URL;

const legalEntitySuggestion =
        [
            {
                value: 0,
                label: "Not Set"
            },
            {
                value: 1,
                label: "Sole Trader"
            },
            {
                value: 2,
                label: "Partnership"
            },
            {
                value: 3,
                label: "Company"
            },
            {
                value: 4,
                label: "Trust"
            },
            {
                value: 5,
                label: "Hobbyist"
            }
        ];
        
@inject("bookingRequestStore", "profileStore", "templateStore", "actTypeStore", "agentVenueStore")
@withRouter
@observer
class BookingActDetails extends Component {
    actSuggestions = [];

    state = {
        showAvailability: false
    }

    getLineupsType = () => {
        let actTypes = [
            { name: "Solo", instrument: 1 },
            { name: "Duo", instrument: 2 },
            { name: "Trio", instrument: 3 },
            { name: "Quartet / 4 Piece", instrument: 4 },
            { name: "Quintet / 5 Piece", instrument: 5 },
            { name: "Sextet / 6 Piece", instrument: 6 }
        ];

        for (var i = 0; i < 93; i++) {
            actTypes.push({ name: i + 7 + " Piece", instrument: i + 7 });
        }
        return actTypes.map(actType => {
            return {
                value: actType.instrument,
                label: actType.name
            };
        });
    };

    componentDidMount() {
        this.props.actTypeStore.loadActTypes().then(() => {

        });
    }

    selectedAct = (value, firstLoad) => {
        const { bookableActs } = this.props.bookingRequestStore;
        this.props.bookingRequestStore.setBooking("actId", value);
        const currentProfile = this.props.profileStore.getCurrentProfile()
        const {booking} = this.props.bookingRequestStore

        // if (!this.props.readOnly) {
        //     this.props.actChange(true)
        // }
        
        this.setTempTitle(firstLoad);
        if (bookableActs) {
            
            var act = bookableActs.filter(x => x.id === value)[0];

            if (act) {
                if(!act.insuranceFiltered){
                     this.props.bookingRequestStore.getActBookingDetails(act.id, act.actAdminId).finally(() => {
                     let actTypeId = act.actTypeId;
                        let lineupCount = act.lineUpCount;
                        if (booking.actType !== actTypeId && act?.id == booking?.act?.id) actTypeId = booking.actType;
                        if (booking.actLineup !== lineupCount && act?.id == booking?.act?.id) lineupCount = booking.actLineup;
                        this.props.bookingRequestStore.setBooking("actType", actTypeId);
                        this.props.bookingRequestStore.setBooking("actLineup", lineupCount);
                        this.props.bookingRequestStore.setBooking("act", act);
                        return act

                    })
                }else{
                    return act
                }
            }else if(!value){
                this.props.bookingRequestStore.setBooking("actType", undefined);
                this.props.bookingRequestStore.setBooking("actLineup", undefined);
                this.props.bookingRequestStore.setBooking("act", null);
                this.props.bookingRequestStore.setBooking("actId", 0);
                return {}
            }
        }
    };
    handleActChange = (value, firstLoad) => {
        const { bookableActs } = this.props.bookingRequestStore;
        this.props.bookingRequestStore.setBooking("actId", value);
        this.props.bookingRequestStore.setErrorAvailablity(false)
        this.props.bookingRequestStore.setShowAvailablity(false)
        const currentProfile = this.props.profileStore.getCurrentProfile()
        const {booking} = this.props.bookingRequestStore

        if (!booking.act && value) {
            const {agentVenues} = this.props.agentVenueStore
            if (currentProfile.type === ProfileType.Agent.ordinal) {
                var agentVenueFiltered = agentVenues.filter(x => x.venueId === booking.venueId)
                if (agentVenueFiltered && agentVenueFiltered.length) {
                    var agentVenue = agentVenueFiltered[0]
                    this.props.bookingRequestStore.setBooking("includeSuper", agentVenue.defaultIncludeSuper);
                }
            }
        }

        if (!this.props.readOnly) {
            this.props.actChange(true)
        }
        
        this.setTempTitle(firstLoad);
        if (bookableActs) {
            var act = bookableActs.filter(x => x.id === value)[0];
             
         if (act) {
                if(!act.insuranceFiltered){
                     act.insuranceFiltered = true;
                     this.props.bookingRequestStore.getActBookingDetails(act.id, act.actAdminId).finally(() => {
                     let actTypeId = act.actTypeId;
                    let lineupCount = act.lineUpCount;
                    if (booking.actType !== actTypeId && act?.id == booking?.act?.id) actTypeId = booking.actType;
                    if (booking.actLineup !== lineupCount && act?.id == booking?.act?.id) lineupCount = booking.actLineup;
                    this.props.bookingRequestStore.setBooking("actType", actTypeId);
                    this.props.bookingRequestStore.setBooking("actLineup", lineupCount);
                    this.props.bookingRequestStore.setBooking("act", act);
                     this.props.actChange(true)
                    })
               

                }else{
                     let actTypeId = act.actTypeId;
                        let lineupCount = act.lineUpCount;
                        if (booking.actType !== actTypeId && act?.id == booking?.act?.id) actTypeId = booking.actType;
                        if (booking.actLineup !== lineupCount && act?.id == booking?.act?.id) lineupCount = booking.actLineup;
                        this.props.bookingRequestStore.setBooking("actType", actTypeId);
                        this.props.bookingRequestStore.setBooking("actLineup", lineupCount);
                        this.props.bookingRequestStore.setBooking("act", act);
                         this.props.actChange(true)
                }
              
                
                
            }else if(!value){
                this.props.bookingRequestStore.setBooking("actType", undefined);
                this.props.bookingRequestStore.setBooking("actLineup", undefined);
                this.props.bookingRequestStore.setBooking("act", null);
                this.props.bookingRequestStore.setBooking("actId", 0);
                 this.props.actChange(true)
            }
        }
    };

    handleActTypeChange = value => {
        this.props.bookingRequestStore.setBooking("actType", value);
        // if (this.props.bookingRequestStore.booking.act == null) {
            this.props.bookingRequestStore.getBookableActs();
        // }
    };

    handleActLineupChange = value => {
        this.props.bookingRequestStore.setBooking("actLineup", value);
        // if (this.props.bookingRequestStore.booking.act == null) {
            this.props.bookingRequestStore.getBookableActs();
        // }
    };

    handleTogleFilterAvailability = value => {
        this.props.bookingRequestStore.setIsFilteredByAvailability()
        
        if(this.props.bookingRequestStore.isFilteredByAvailability && this.props.bookingRequestStore.bookableActsFiltered && this.props.bookingRequestStore.bookableActsFiltered.length ){
            this.props.bookingRequestStore.setBookableAct(this.props.bookingRequestStore.bookableActsFiltered)
        }else{
            this.props.bookingRequestStore.getBookableActs().then(() => {

        })
        }
       
    }

    checkAvailability = value => {
         this.props.bookingRequestStore.checkAvailability(value.id).then((result) => {
         
        })
    }

    handleDownloadInsuranceDocument = (act) => {
        if(!act){
             act = this.props.bookingRequestStore.booking.act

        }else
        
         Storage.get(act.insuranceFileContentUrl)
                .then(result => window.open(result))
                .catch(err => console.log(err));
      
    }

    mapActSuggestions = () => {
        const { bookableActs } = this.props.bookingRequestStore;

        if (bookableActs) {
            return bookableActs.map(act => {
                return {
                    value: act.id,
                    label: act.actName
                };
            });
        }
        return [];
    };

    setTempTitle = (firstLoad) => {
        const { bookableActs, booking } = this.props.bookingRequestStore;
        const { actId, venue, venueName } = booking;
        var title = "";

        var act = bookableActs ? bookableActs.filter(x => x.id === actId)[0] : null;
        title = `${act ? act.actName : ""} @ ${venue ? venue.profileName : venueName}`;

        this.props.bookingRequestStore.setBooking("tempTitle", title);
        if(!firstLoad) this.props.bookingRequestStore.setBooking("title", title);
        if (!booking?.actFee) this.props.bookingRequestStore.setBooking("actFee", 0);
        this.props.bookingRequestStore.setBooking("actName", act ? act.actName : "");
        this.props.bookingRequestStore.setTempBookingTitle();
    };

    mapActTypeSuggestions = () => {
        const { actTypes } = this.props.actTypeStore;
        return actTypes.map(actType => {
            return {
                value: actType.id,
                label: actType.name
            };
        });
    };

    anyError(field) {
        return false;
    }

    errorText(field) {
        // if (!this.props.generalProfileStore.errors) return null;
        // if (!this.props.generalProfileStore.errors[field]) return null;
        // return this.props.generalProfileStore.errors[field];
    }

    getActTypeValue = (id) => {
        const { actTypes } = this.props.actTypeStore;
        let result = ""
        actTypes.forEach(x => {
            if (x.id == id) result = x.name
        })
        return result
    }

    getLineupValue = (id) => {
        let actTypes = [
            { name: "Solo", instrument: 1 },
            { name: "Duo", instrument: 2 },
            { name: "Trio", instrument: 3 },
            { name: "Quartet / 4 Piece", instrument: 4 },
            { name: "Quintet / 5 Piece", instrument: 5 },
            { name: "Sextet / 6 Piece", instrument: 6 }
        ];

        let result = ""
        actTypes.forEach(x => {
            if (x.instrument == id) result = x.name
        })
        return result
    }

    getAvailabilityComponent = (selectedAct, isDisabled) => {
        const { isFilteredByAvailability } = this.props.bookingRequestStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const isMusician = currentProfile && currentProfile?.type === ProfileType.Musician.ordinal;

        if (isMusician) {
            return null;
        }

        return (
            <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                {
                    selectedAct && !isFilteredByAvailability ?
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className="action-button booking-details"
                            disabled={isDisabled || this.props.readOnly}
                            style={{ marginTop: 20 }}
                            onClick={() => this.checkAvailability(selectedAct)}
                        >
                            Check Availability
                        </Button>
                        :
                        <Grid item md={12} xs={12}>
                            <p style={{ marginTop: 10, fontSize: 14, fontWeight: 900 }}>
                                <Switch disabled={isDisabled || this.props.readOnly} checked={isFilteredByAvailability} onChange={this.handleTogleFilterAvailability} value="hideToolbar2" />
                                only show available acts
                            </p>
                        </Grid>
                }
            </Grid>
        );
    }


    render() {
        const { error, booking, isActLoaded, showAvailability,errorAvailability, isFilterLoaded } = this.props.bookingRequestStore;

        const { actId, act, status, bookingRequests, createdBy, isAdmin,bookingRequest, actType, actLineup, forceAct, isPayByActOwner } = booking;

        const { readOnly } = this.props;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        var isMusician = currentProfile && currentProfile?.type === ProfileType.Musician.ordinal;
        var isAgent = currentProfile && currentProfile?.type === ProfileType.Agent.ordinal;
        var isStaff = currentProfile && currentProfile?.type === ProfileType.Staff.ordinal;
        let countryName = "";
        // if (!act && this.props.bookingRequestStore.actId && this.props.bookingRequestStore.actId != undefined && this.props.bookingRequestStore.actId != "undefined") {
        //     this.handleActChange(parseInt(this.props.bookingRequestStore.actId));
        // }

        let resentAct = booking.bookingRequests && booking.bookingRequests.length > 0 && booking.bookingRequests[booking.bookingRequests.length - 1].act;
        var bookingRequestName = bookingRequests?.map(x=>x.act?.actName)

        if(currentProfile?.type != ProfileType.Staff.ordinal && booking.createdById != currentProfile?.id){
            var bookingRequestSpecific = bookingRequests?.filter(x=>x.act?.actAdminId === currentProfile?.id)
            bookingRequestName = bookingRequestSpecific?.map(x=>x.act?.actName)
        }

        if (actId) {
            var selectedAct = this.selectedAct(parseInt(actId), true)
            if(!selectedAct){
                selectedAct = act
            }
        }
        if (resentAct) {
            selectedAct = resentAct;
        }
        if (selectedAct) {
            let country = Countries.filter(x => x.code === selectedAct.countryCode);
            if (country.length > 0) {
                countryName = country[0].name;
            }
        }
        let insurancePdfLink = "";
        if (selectedAct) {
            insurancePdfLink = `${API_ROOT}/document/${selectedAct.insuranceFileGuid}/${selectedAct.insuranceFileName}`;
        }
        var canModify = booking && currentProfile && booking.createdById === currentProfile?.id
        var legalEntityLabel = "Not set"
         var legalEntity = legalEntitySuggestion.filter(x=>x.value === act?.actAdmin?.legalEntity)
            if(legalEntity && legalEntity.length) legalEntityLabel = legalEntity[0].label
        return (
            <Grid>
            { resentAct ? 
             <TextField
                label="Act Name"
                inputProps={{
                    readOnly: true
                }}
                value={bookingRequestName.length ? bookingRequestName?.join(", "): ""}
                fullWidth
            />     :
               <Grid container spacing={8}>
                <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                    {readOnly ? 
                        <TextField
                            label="Act Type"
                            inputProps={{
                                readOnly: true
                            }}
                            value={this.getActTypeValue(actType)}
                            fullWidth
                        />    :
                        <SelectField
                            id="bookingActType"
                            label="Act Type"
                            value={actType}
                            suggestions={this.mapActTypeSuggestions()}
                            placeholder="Select Act Type"
                            onChange={this.handleActTypeChange}
                        />
                }
                </Grid>
                <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                    {readOnly ?
                        <TextField
                            label="Lineup"
                            inputProps={{
                                readOnly: true
                            }}
                            value={this.getLineupValue(actLineup)}
                            fullWidth
                        />    :    
                        <SelectField
                            id="bookingActLineupType"
                            label="Lineup"
                            value={actLineup}
                            suggestions={this.getLineupsType()}
                            placeholder="Select Lineup Numbers"
                            onChange={this.handleActLineupChange}
                        />
                }
                </Grid>
                    {
                        (
                            isAgent ||
                            isStaff ||
                            isMusician
                        ) &&
                            (
                                status === BookingStatusType.Resent.ordinal
                            ) && !bookingRequest && !forceAct ?
                            (createdBy &&
                                status === BookingStatusType.Resent.ordinal && currentProfile?.id == booking.createdById ? (
                                    <Fragment>
                                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                                            <TextField
                                                label="Act Name"
                                                inputProps={{
                                                    readOnly: true
                                                }}
                                                value={selectedAct ? selectedAct.actName : ""}
                                                onChange={this.handleActNameChange}
                                                fullWidth
                                            />

                                        </Grid>
                                        {this.getAvailabilityComponent(selectedAct, true)}
                                    </Fragment>
                                
                                // <SelectField
                                //     id="bookingAct"
                                //     label="Acts"
                                //     multi={true}
                                //     suggestions={this.mapActSuggestions()}
                                //     value={bookingRequests ? bookingRequests.filter(x => !x.deleted).map(y => y.actId) : 0}
                                //     placeholder={isActLoaded ? "Select Act" : isFilterLoaded ? "Hang tight... we're checking for available acts for this date and time" : "Loading Acts"}
                                //     disabled={true}
                                //     emptyText="No act available on selected times"
                                // />
                            ) : (
                                   <Fragment>
                                        <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                                             <SelectField
                                                id="bookingAct"
                                                label="Act"
                                                suggestions={this.mapActSuggestions()}
                                                onChange={this.handleActChange}
                                                value={resentAct ? resentAct.id : actId}
                                                paginated
                                                pageSize={20}
                                                disabled={!isActLoaded}
                                                placeholder={isActLoaded ? "Select Act" : isFilterLoaded ? "Hang tight... we're checking for available acts for this date and time" : "Loading Acts"}
                                                error={error && error["act"]}
                                                helperText={error && error["act"] ? error["act"] : ""}
                                                emptyText="No act available on selected times"
                                            />

                                        </Grid>
                                        {this.getAvailabilityComponent(selectedAct, false)}
                                    </Fragment>
                               
                            )
                            ) : isMusician && bookingRequest ? (
                                <Fragment>
                                    <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                                        <TextField
                                            label="Act Name"
                                            inputProps={{
                                                readOnly: true
                                            }}
                                            value={bookingRequest.act.actName}
                                            fullWidth
                                        />

                                    </Grid>
                                    {this.getAvailabilityComponent(selectedAct,true)}
                                </Fragment>
                                
                            ) : !readOnly && (canModify || (isAdmin && (currentProfile?.type === ProfileType.Staff.ordinal || currentProfile?.type === ProfileType.Agent.ordinal)) || !booking || !booking.id) ? (
                                <Fragment>
                                    <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                                         <SelectField
                                            id="bookingAct"
                                            label="Act"
                                            suggestions={this.mapActSuggestions()}
                                            onChange={this.handleActChange}
                                            value={resentAct ? resentAct.id : actId}
                                            paginated
                                            pageSize={20}
                                            disabled={!isActLoaded}
                                            placeholder={isActLoaded ? "Select Act" : isFilterLoaded ? "Hang tight... we're checking for available acts for this date and time" : "Loading Acts"}
                                            error={error && error["act"]}
                                            helperText={error && error["act"] ? error["act"] : ""}
                                            emptyText="No act available on selected times"
                                        />

                                    </Grid>
                                    {this.getAvailabilityComponent(selectedAct, false)}
                                </Fragment>
                               
                            ) : 
                             <Fragment>
                                    <Grid item xs={12} lg={6} className="gridPrivateBookingForm">
                                         <TextField
                                            label="Act Name"
                                            inputProps={{
                                                readOnly: true
                                            }}
                                            value={selectedAct ? selectedAct.actName : ""}
                                            onChange={this.handleActNameChange}
                                            fullWidth
                                        />

                                    </Grid>
                                    {this.getAvailabilityComponent(selectedAct, true)}
                                </Fragment>
                           
                        }
                { selectedAct && showAvailability ? 
                errorAvailability ? 
                    <Fragment>
                        <Grid item xs={12} lg={12}>
                            <p style={{ color:"red",marginTop: 10, fontSize: 14, fontWeight: 900 }}>
                                This act is unavailable
                            </p>  
                        </Grid>
                    </Fragment>
                    :  <Fragment>
                            <Grid item xs={12} lg={12}>
                                <p style={{ color:"green",marginTop: 10, fontSize: 14, fontWeight: 900 }}>
                                    This act is available
                                </p>  
                            </Grid>
                        </Fragment>
                    : null
                   
                }
              
                {selectedAct &&
                    !isMusician && (
                        <Fragment>
                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="email"
                                    label="Email"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.email || ""}
                                    readOnly
                                    error={this.anyError("email")}
                                    helperText={this.errorText("email")}
                                />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="contactPhone"
                                    label="Phone"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.contactPhone || ""}
                                    readOnly
                                    error={this.anyError("contactPhone")}
                                    helperText={this.errorText("contactPhone")}
                                />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="street"
                                    label="Street Address"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.street || ""}
                                    readOnly
                                    error={this.anyError("street")}
                                    helperText={this.errorText("street")}
                                />
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="city"
                                    label="Suburb"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.city || ""}
                                    onChange={this.handleCityChange}
                                    error={this.anyError("city")}
                                    helperText={this.errorText("city")}
                                />
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="postal"
                                    label="Postal/Zip Code"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.postal || ""}
                                    readOnly
                                    error={this.anyError("postal")}
                                    helperText={this.errorText("postal")}
                                />
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="state"
                                    label="State"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.state || ""}
                                    readOnly
                                    error={this.anyError("state")}
                                    helperText={this.errorText("state")}
                                />
                            </Grid>

                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="countries"
                                    label="Country"
                                    margin="dense"
                                    fullWidth
                                    value={countryName || ""}
                                    readOnly
                                    error={this.anyError("country")}
                                    helperText={this.errorText("country")}
                                />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField
                                    id="abn"
                                    label="ABN"
                                    margin="dense"
                                    fullWidth
                                    value={selectedAct.abn || ""}
                                    readOnly
                                    error={this.anyError("abn")}
                                    helperText={this.errorText("abn")}
                                />
                            </Grid>
                             <Grid item xs={12} md={6}>
                                <TextField
                                    id="legalEntity"
                                    label="Legal Entity"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={legalEntityLabel}
                                    error={this.anyError("legalEntity")}
                                    helperText={this.errorText("legalEntity")}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="isSuperCompleted"
                                    label="Full Super Details Added"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={act?.isSuperCompleted ? "Yes" : "No"}
                                    error={this.anyError("isSuperCompleted")}
                                    helperText={this.errorText("isSuperCompleted")}
                                />
                            </Grid>
                    
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="insurancePolicyHolder"
                                    label="Policy Holder Name"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={selectedAct.insurancePolicyHolder || ""}
                                    error={this.anyError("insurancePolicyHolder")}
                                    helperText={this.errorText("insurancePolicyHolder")}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="insuranceCompany"
                                    label="Insurance Company"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={selectedAct.insuranceCompany || ""}
                                    error={this.anyError("insuranceCompany")}
                                    helperText={this.errorText("insuranceCompany")}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="insurancePolicyNumber"
                                    label="Insurance Policy Number"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={selectedAct.insurancePolicyNumber || ""}
                                    error={this.anyError("insurancePolicyNumber")}
                                    helperText={this.errorText("insurancePolicyNumber")}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id="insuranceExpiryDate"
                                    label="Insurance Expiry Date"
                                    margin="dense"
                                    fullWidth
                                    readOnly
                                    value={selectedAct.insuranceExpiryDate ? moment(selectedAct.insuranceExpiryDate).format("DD-MM-YYYY") : ""}
                                    error={this.anyError("insuranceExpiryDate")}
                                    helperText={this.errorText("insuranceExpiryDate")}
                                />
                            </Grid>
                    
                          
                                {selectedAct.insuranceFileGuid && (
                                      <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="insuranceFileName">Insurance File</InputLabel>
                                        <Input
                                            id="insuranceFileName"
                                            value={selectedAct.insuranceFileName}
                                            startAdornment={
                                                <InputAdornment
                                                    onClick={() => this.handleDownloadInsuranceDocument(selectedAct)}
                                                    position="start"
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <a target="_blank">
                                                        <CloudDownload />
                                                    </a>
                                                </InputAdornment>
                                            }
                                            readOnly={true}
                                        />
                                    </FormControl>
                                    </Grid>
                                )}
                            
                             
                        </Fragment>
                    )}
            </Grid>
        } 
        </Grid>
        );
    }
}

export default BookingActDetails;
